module.exports = __webpack_public_path__ + "static/media/sort-arrow-ASC.94af1085.svg";